import _ from "underscore";

import { SERVICE_MENU_STATUS_SUMMARY_TEXT, ServiceMenuStatus } from "@/consts/const";
import { ServiceMenuEventInterface } from "@/interfaces/service-menu-event.interface";
import { ServiceMenuStatusInterface } from "@/interfaces/service-menu-status.interface";
import i18n from "@/main";

/**
 * ステータス関連ユーティリティ
 */
export class StatusUtil {
  /**
   * ステータス説明文を取得する
   */
  public static getMessage(data: ServiceMenuStatusInterface): string {
    const status = StatusUtil.getMessageStatus(data);

    if (status === ServiceMenuStatus.Ok) {
      return i18n.t(SERVICE_MENU_STATUS_SUMMARY_TEXT[ServiceMenuStatus.Ok]);
    }

    return data[status] as string;
  }

  /**
   * 全てのステータス状態を取得する
   */
  public static getAllStatus(
    status: ServiceMenuStatusInterface
  ): ServiceMenuStatus[] {
    const items: ServiceMenuStatus[] = [StatusUtil.getStatus(status)];

    [ServiceMenuStatus.Notification].forEach((s: ServiceMenuStatus) => {
      if (_.isString(status[s] as unknown)) {
        items.push(s);
      }
    });

    return items;
  }

  /**
   * 全てのステータス状態を取得する
   */
  public static getAllEventStatus(
    status: ServiceMenuStatusInterface
  ): ServiceMenuStatus[] {
    const items: ServiceMenuStatus[] = StatusUtil.getEventStatusList(status);

    [ServiceMenuStatus.Notification].forEach((s: ServiceMenuStatus) => {
      if (_.isString(status[s] as unknown)) {
        items.push(s);
      }
    });

    return items;
  }

  /**
   * イベント一覧からステータスデータを取り出す
   */
  public static getEventStatusData(
    events: ServiceMenuEventInterface[]
  ): ServiceMenuStatusInterface {
    const data: ServiceMenuStatusInterface = {
      [ServiceMenuStatus.Warning]: "",
      [ServiceMenuStatus.Error]: "",
      [ServiceMenuStatus.Notification]: "",
    };

    events.forEach((event: ServiceMenuEventInterface) => {
      if (data[event.status] === "") {
        data[event.status] = event.statusText;
      }
    });

    // eslint-disable-next-line
    _.keys(data).forEach((key: any) => {
      if (data[key] === "") {
        delete data[key];
      }
    });

    return data;
  }

  /**
   * 1つの説明文だけを表示する際の対象ステータスを取得する
   */
  public static getMessageStatus(
    status: ServiceMenuStatusInterface
  ): ServiceMenuStatus {
    if (_.isString(status[ServiceMenuStatus.Error])) {
      return ServiceMenuStatus.Error;
    } else if (_.isString(status[ServiceMenuStatus.Warning])) {
      return ServiceMenuStatus.Warning;
    }

    if (_.isString(status[ServiceMenuStatus.Notification])) {
      return ServiceMenuStatus.Notification;
    }

    return ServiceMenuStatus.Ok;
  }

  /**
   * ステータスを取得する: 正常、一部障害、障害のいずれか
   */
  public static getStatus(
    status: ServiceMenuStatusInterface
  ): ServiceMenuStatus {
    if (_.isString(status[ServiceMenuStatus.Error])) {
      return ServiceMenuStatus.Error;
    } else if (_.isString(status[ServiceMenuStatus.Warning])) {
      return ServiceMenuStatus.Warning;
    } else {
      return ServiceMenuStatus.Ok;
    }
  }

  /**
   * 内部イベント型のステータス一覧を取得する: 正常、一部障害、障害、一部障害・障害のいずれか
   */
  public static getEventStatusList(
    status: ServiceMenuStatusInterface
  ): ServiceMenuStatus[] {
    const statusList: ServiceMenuStatus[] = [];

    if (_.isString(status[ServiceMenuStatus.Warning])) {
      statusList.push(ServiceMenuStatus.Warning);
    }

    if (_.isString(status[ServiceMenuStatus.Error])) {
      statusList.push(ServiceMenuStatus.Error);
    }

    if (statusList.length === 0) {
      return [ServiceMenuStatus.Ok];
    }

    return statusList;
  }
}
